import installQuasar from './install-quasar.js'
import lang from './lang.js'
import iconSet from './icon-set.js'

export default {
  version: __QUASAR_VERSION__,
  install: installQuasar,
  lang,
  iconSet
}
